import React from "react";

// @material-ui/core
// core components
import Grid from "@mui/material/Grid";
import NodeCard from "components/Card/NodeCard";
import PodCard from "components/Card/PodCard";
import HelmCard from "components/Card/HelmCard";
import CertCard from "components/Card/CertCard";
import MDBox from "components/MDBox";
import NodeTable from "components/Table/NodeTable";

export default function Dashboard() {
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <NodeCard/>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <PodCard/>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <HelmCard/>
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <CertCard/>
          </MDBox>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12} mt={2}>
          <MDBox>
            <NodeTable/>
          </MDBox>
        </Grid>
      </Grid>
    </div>
  );
}
